import apiCallTemplate from './config'
import credentials from '../assets/credentials'

const {BASE_URL}=credentials
const blogURL = `${BASE_URL}/blog`;

//creat blog posts
export const createPost=async (postData, file)=>apiCallTemplate("post", `${blogURL}`, postData, file)

//Get all posts
export const allPosts=async (query)=>apiCallTemplate("get", `${blogURL}${query || ""}`)

//Get blog post by id
export const getPost=async (id)=>apiCallTemplate("get", `${blogURL}/${id}`)

//Get Post Image
export const postImage=async (imageNodeId)=>apiCallTemplate("get", `${blogURL}/image/view/${imageNodeId}`);

//Update Post
export const updatePost=async (id, postData, file)=>apiCallTemplate("put", `${blogURL}/${id}`, postData, file)

//Delete Post
export const deletePost=async (id)=>apiCallTemplate("delete", `${blogURL}/${id}`)